import React from 'react';

import { FormControl } from 'components/v2/Form/FormControl/FormControl';
import { getFormControlIds } from 'components/v2/Form/FormControl/FormControl.utils';
import { DateInput } from 'components/v2/Inputs/DateInput/DateInput';

import { Props } from './DateField.types';

export const DateField = ({
  status = 'default',
  label,
  id,
  required,
  helperText,
  description,
  hideDescription,
  placeholder,
  autoComplete,
  value,
  onChange,
  onBlur,
  onFocus,
  onKeyDown,
  dateFormat,
  onSelect,
  labelBg,
  hideHelperText,
  blockFutureDays
}: Props) => {
  const ids = getFormControlIds(id);

  return (
    <FormControl
      status={status}
      label={label}
      required={required}
      helperText={helperText}
      description={description}
      hideDescription={hideDescription}
      labelId={ids.label}
      inputId={ids.input}
      helperTextId={ids.helperText}
      labelBg={labelBg}
      hideHelperText={hideHelperText}
    >
      <DateInput
        id={ids.input}
        labelId={ids.label}
        status={status}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        dateFormat={dateFormat}
        onSelect={onSelect}
        blockFutureDays={blockFutureDays}
      />
    </FormControl>
  );
};
